module.exports = __webpack_public_path__ + "static/media/oracle.cb0becd1.png";